export default __webpack_public_path__ + "static/media/secondPaneBgSmall.c2713597.jpg";